// StandardCakeFields.jsx
import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const StandardCakeFields = ({
  item,
  updateItem,
  flavors,
  sizes,
  cheesecakes,
}) => {
  const getAvailableFlavors = () => {
    if (item.type === "cheesecake") {
      const unique = [
        ...new Set(cheesecakes.map((c) => c.flavor).filter(Boolean)),
      ];
      return unique.map((f) => ({ name: f, displayName: f }));
    }

    return flavors.filter((f) => f.category?.includes(item.type));
  };

  const getAvailableSizes = () => {
    const simplified = item.type.replace(/([A-Z].*)$/, "").toLowerCase();
    return sizes.filter((s) => s.category === simplified);
  };

  const handleFlavorSelect = (e) => {
    const selectedLabel = e.target.value;
    const selected = flavors.find((f) => f.displayName === selectedLabel);

    if (!selected) return;

    const updates = {
      flavor: {
        _id: selected._id || null,
        name: selected.displayName,
        internalName: selected.name || "",
        image: selected.images?.primary || "",
      },
    };

    if (["standardCake", "cheesecake"].includes(item.type)) {
      updates.image = selected.images?.primary || selected.image || "";
    }

    updateItem(item._id, updates);
  };

  const handleSizeChange = (e) => {
    const selectedSize = sizes.find((s) => s._id === e.target.value);
    if (selectedSize) {
      updateItem(item._id, { size: selectedSize });
    }
  };

  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          select
          label="Flavor"
          fullWidth
          value={item.flavor?.name || ""}
          onChange={handleFlavorSelect}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 300,
                  overflowY: "auto",
                },
              },
            },
          }}>
          <MenuItem value="">
            <em>Select a flavor</em>
          </MenuItem>
          {getAvailableFlavors().map((flavor) => (
            <MenuItem
              key={flavor._id || flavor.name}
              value={flavor.displayName}>
              {flavor.displayName || flavor.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          select
          label="Size"
          fullWidth
          value={item.size?._id || ""}
          onChange={handleSizeChange}>
          {getAvailableSizes().map((size) => (
            <MenuItem key={size._id} value={size._id}>
              {size.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </>
  );
};

export default StandardCakeFields;
